import * as React from 'react'
import { Row, Col, Button } from 'reactstrap';
import { useAuth } from 'src/modules/Auth/hooks/useAuth';
import { UserTypes } from 'src/modules/Auth/store/types';
import { useHistory } from 'react-router';
import { BeatLoader } from 'react-spinners';
import { toastr } from 'react-redux-toastr';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { HelpService } from 'src/share/services/help';
import { IHelpContent, initialHelpArticle } from '../types/help';
import "./HelpArticle.css";

function HelpArticle(props) {
  const history = useHistory();
  const [auth] = useAuth();
  const [article, setArticle] = React.useState<IHelpContent>(initialHelpArticle);
  const [isLoading, setIsLoading] = React.useState(true);
  const [isModalToggled, setIsModalToggled] = React.useState(false);
  const { categoryName, categoryId, articleId } = props.match.params;
  const isAdmin = auth.userType === UserTypes.ADMIN;
  React.useEffect(() => {
    fetchData();
  }, [])
  async function fetchData() {
    try {
      setIsLoading(true);
      const newArticle = await HelpService.getArticleById(articleId);
      if (newArticle) {
        setArticle(newArticle);
        setIsLoading(false);
      } else {
        history.push('/help');
        toastr.error('There was a problem loading the article');
      }
    } catch {
      toastr.error('Error', 'There was a problem connecting to the server');
      setIsLoading(false);
    }
  }
  async function handleArticleDeleted(): Promise<void> {
    try {
      setIsLoading(true);
      await HelpService.deleteArticleById(article.articleId as string);
      setTimeout(() => history.push(`/help`), 2000);
    } catch (error) {
      setIsLoading(false);
      toastr.error('There was a problem', 'The article could not be deleted');
    }
  }
  function getHTML(htmlString: string) {
    return { __html: htmlString }
  }
  return (
    <div className="help-center__container">
      {!isLoading &&
        <div className="white-background help-content">
          <Row>
            <Col className="col-md-12">
              <div className="article-view-nav nav-article">
                <h2 onClick={() => history.push('/help')}>Support</h2>
                <h2 className="separator">&gt;</h2>
                <h2 onClick={() => history.push(`/help/category/${categoryId}`)}>{categoryName}</h2>
                <h2 className="separator">&gt;</h2>
                <h2>{article.title}</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="col-md-12">
              <h2 className="help-article-title-view">{article.title}</h2>
              <div className="help-article-view" dangerouslySetInnerHTML={getHTML(article.content || '')} />
              {isAdmin &&
                <Button 
                  className="btn float-right btn-green-fill btn-help" 
                  onClick={() => history.push({ pathname: `/help/form/${categoryName}/${categoryId}/${articleId}`, state: { isEditing: true } })}
                >
                  Edit
                </Button>}
              {isAdmin &&
                <Button className="btn float-right btn-grey-fill btn-help" onClick={() => setIsModalToggled(prevIsModalToggled => !prevIsModalToggled)}>
                  Delete
                  </Button>}
            </Col>
          </Row>
        </div>}
      <div className="help-loader">
        <BeatLoader loading={isLoading} />
      </div>
      <ConfirmationModal
        isOpen={isModalToggled}
        toggle={() => setIsModalToggled(prevIsModalToggled => !prevIsModalToggled)}
        title={'Delete article'}
        description={isLoading ? 'Deleting article...' : 'Do you want to delete this article?'}
        onContinue={handleArticleDeleted}
        loading={isLoading}
        showButtons={!isLoading}
      />
    </div>
  )
}

export default HelpArticle
